<template>
    <div class="editSpecialNews">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>商业专题</el-breadcrumb-item>
            <el-breadcrumb-item>编辑新闻</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="edit-special-news-box">
            <div class="special-list-box">
                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                <el-tree class="tree" :data="specialList" ref="specialTree" :props="propsRules" :filter-node-method="filterNode" @node-click="selectSpecial" :highlight-current="true"></el-tree>
            </div>
            <div class="news-contents-box" v-if="newsList">
                <div class="refresh-btn-box" @click="refreshNews">
                    <img src="../../../assets/refresh.png" alt="刷新">
                </div>
                <div class="head-image-box" v-if="newsList[0].newsTypeName === '头图'">
                    <HeadImgComponent :newsData="headImg" :isAd="newsList[0].isAd === 1" :showControl="true"></HeadImgComponent>
                    <el-button-group v-if="showControl">
                        <el-button type="primary" icon="edit" size="mini" @click="editHeadImg"></el-button>
                        <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsList[0].newsContentId)"></el-button>
                    </el-button-group>
                </div>
                <div class="special-desc-box" v-if="currentSpecial.isShowDes">
                    <div class="desc-icon">概述</div>
                    <span class="desc-content">{{currentSpecial.specialContent}}</span>
                </div>
                <div class="news-list-box" v-if="newsList && newsList.length > 0">
                    <template v-for="(newsItem,index) in newsList">
                        <div class="news-item-box" v-if="newsItem.newsTypeName === '无图新闻'">
                            <TextComponent :newsData="newsItem" :isAd="newsItem.isAd === 1" :showControl="true"></TextComponent>
                            <el-button-group v-if="showControl">
                                <el-button type="primary" size="mini" @click="moveUp(index)" v-if="newsList[0].newsTypeName === '头图'?index > 1: index > 0">上移</el-button>
                                <el-button type="primary" size="mini" @click="moveDown(index)" v-if="index < newsList.length -1">下移</el-button>
                                <el-button type="primary" icon="edit" size="mini" @click="editNews(newsItem)"></el-button>
                                <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsItem.newsContentId)"></el-button>
                            </el-button-group>
                        </div>
                        <div class="news-item-box" v-else-if="newsItem.newsTypeName === '单图新闻'">
                            <OneImgComponent :newsData="newsItem" :isAd="newsItem.isAd === 1" :showControl="true"></OneImgComponent>
                            <el-button-group v-if="showControl">
                                <el-button type="primary" size="mini" @click="moveUp(index)" v-if="newsList[0].newsTypeName === '头图'?index > 1: index > 0">上移</el-button>
                                <el-button type="primary" size="mini" @click="moveDown(index)" v-if="index < newsList.length -1">下移</el-button>
                                <el-button type="primary" icon="edit" size="mini" @click="editNews(newsItem)"></el-button>
                                <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsItem.newsContentId)"></el-button>
                            </el-button-group>
                        </div>
                        <div class="news-item-box" v-else-if="newsItem.newsTypeName === '大图新闻'">
                            <BigImgComponent :newsData="newsItem" :isAd="newsItem.isAd === 1" :showControl="true"></BigImgComponent>
                            <el-button-group v-if="showControl">
                                <el-button type="primary" size="mini" @click="moveUp(index)" v-if="newsList[0].newsTypeName === '头图'?index > 1: index > 0">上移</el-button>
                                <el-button type="primary" size="mini" @click="moveDown(index)" v-if="index < newsList.length -1">下移</el-button>
                                <el-button type="primary" icon="edit" size="mini" @click="editNews(newsItem)"></el-button>
                                <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsItem.newsContentId)"></el-button>
                            </el-button-group>
                        </div>
                        <div class="news-item-box" v-else-if="newsItem.newsTypeName === '多图新闻'">
                            <ThreeImgComponent :newsData="newsItem" :isAd="newsItem.isAd === 1" :showControl="true"></ThreeImgComponent>
                            <el-button-group v-if="showControl">
                                <el-button type="primary" size="mini" @click="moveUp(index)" v-if="newsList[0].newsTypeName === '头图'?index > 1: index > 0">上移</el-button>
                                <el-button type="primary" size="mini" @click="moveDown(index)" v-if="index < newsList.length -1">下移</el-button>
                                <el-button type="primary" icon="edit" size="mini" @click="editNews(newsItem)"></el-button>
                                <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsItem.newsContentId)"></el-button>
                            </el-button-group>
                        </div>
                        <div class="news-item-box" v-else-if="newsItem.newsTypeName === '视频新闻'">
                            <VideoComponent :newsData="newsItem" :isAd="newsItem.isAd === 1" :showControl="true"></VideoComponent>
                            <el-button-group v-if="showControl">
                                <el-button type="primary" size="mini" @click="moveUp(index)" v-if="newsList[0].newsTypeName === '头图'?index > 1: index > 0">上移</el-button>
                                <el-button type="primary" size="mini" @click="moveDown(index)" v-if="index < newsList.length -1">下移</el-button>
                                <el-button type="primary" icon="edit" size="mini" @click="editNews(newsItem)"></el-button>
                                <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsItem.newsContentId)"></el-button>
                            </el-button-group>
                        </div>
                        <div class="news-item-box" v-else-if="newsItem.newsTypeName === '图集'">
                            <ImgListComponent :newsData="newsItem" :isAd="newsItem.isAd === 1" :showControl="true"></ImgListComponent>
                            <el-button-group v-if="showControl">
                                <el-button type="primary" size="mini" @click="moveUp(index)" v-if="newsList[0].newsTypeName === '头图'?index > 1: index > 0">上移</el-button>
                                <el-button type="primary" size="mini" @click="moveDown(index)" v-if="index < newsList.length -1">下移</el-button>
                                <el-button type="primary" icon="edit" size="mini" @click="editNews(newsItem)"></el-button>
                                <el-button type="primary" icon="delete" size="mini" @click="deleteNews(newsItem.newsContentId)"></el-button>
                            </el-button-group>
                        </div>
                    </template>
                    <el-dialog title="编辑新闻" v-model="config.editNewsDialog.visible" :lock-scroll="true" @close="closeEditNewsDialog">
                        <el-form v-if="config.editNewsDialog.newsTypeName === '无图新闻'" :model="config.editNewsDialog.newsItem" ref="textNews">
                            <el-form-item label="标题"  prop="newsContentTitle">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentTitle" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="来源"  prop="newsContentSource">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentSource" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="置顶权重"  prop="newsContentIsTop">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentIsTop" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="落地链接"  prop="newsContentURL">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentURL" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-if="config.editNewsDialog.newsTypeName === '单图新闻'" :model="config.editNewsDialog.newsItem" ref="oneImgNews">
                            <el-form-item label="标题" prop="newsContentTitle">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentTitle" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="来源" prop="newsContentSource">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentSource" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="置顶权重" prop="newsContentIsTop">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentIsTop" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="落地链接" prop="newsContentURL">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentURL" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="图片链接" prop="newsContentImage">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentImage" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-if="config.editNewsDialog.newsTypeName === '大图新闻'" :model="config.editNewsDialog.newsItem" ref="bigImgNews">
                            <el-form-item label="标题"  prop="newsContentTitle">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentTitle" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="来源"  prop="newsContentSource">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentSource" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="置顶权重"  prop="newsContentIsTop">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentIsTop" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="落地链接"  prop="newsContentURL">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentURL" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="图片链接"  prop="newsContentImage">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentImage" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-if="config.editNewsDialog.newsTypeName === '多图新闻'" :model="config.editNewsDialog.newsItem" ref="threeImgNews">
                            <el-form-item label="标题"  prop="newsContentTitle">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentTitle" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="来源"  prop="newsContentSource">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentSource" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="置顶权重"  prop="newsContentIsTop">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentIsTop" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="落地链接"  prop="newsContentURL">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentURL" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item :label="'图片链接' + (index + 1)" v-for="(imageItem, index) in config.editNewsDialog.newsItem.newsContentImage" :key="index" prop="newsContentImage">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentImage[index]" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-if="config.editNewsDialog.newsTypeName === '图集'" :model="config.editNewsDialog.newsItem" ref="imgListNews">
                            <el-form-item label="来源"  prop="newsContentSource">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentSource" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="置顶权重"  prop="newsContentIsTop">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentIsTop" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item :label="'图片链接' + (index + 1)" v-for="(imageItem, index) in config.editNewsDialog.newsItem.newsContentImage" :key="index" prop="newsContentImage">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentImage[index]" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-if="config.editNewsDialog.newsTypeName === '视频新闻'" :model="config.editNewsDialog.newsItem" ref="videoNews">
                            <el-form-item label="标题"  prop="newsContentTitle">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentTitle" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="来源"  prop="newsContentSource">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentSource" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="置顶权重"  prop="newsContentIsTop">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentIsTop" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="视频链接"  prop="newsContentURL">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentURL" auto-complete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="封皮图片链接"  prop="newsContentImage">
                                <el-input v-model="config.editNewsDialog.newsItem.newsContentImage" auto-complete="off"></el-input>
                            </el-form-item>
                        </el-form>
                        <el-form v-if="config.editNewsDialog.newsTypeName === '头图'"ref="headImg">
                            <template v-for="(imageItem, index) in headImg">
                                <el-card class="box-card">
                                    <el-form-item label="图片链接"  prop="image">
                                        <el-input v-model="headImg[index].image" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="落地链接"  prop="link">
                                        <el-input v-model="headImg[index].link" auto-complete="off"></el-input>
                                    </el-form-item>
                                </el-card>
                            </template>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button v-if="config.editNewsDialog.newsTypeName === '头图' && headImg.length > 1" @click="deleteHeadImgCard">删除卡片</el-button>
                            <el-button v-if="config.editNewsDialog.newsTypeName === '头图'" @click="addHeadImgCard" type="primary">增加卡片</el-button>
                            <el-button @click="closeEditNewsDialog">取 消</el-button>
                            <el-button type="primary" @click="submitEditData">确 定</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <div class="add-news-box" v-if="currentSpecial">
                <div class="select-template-box">
                    <div class="header">项目和组件</div>
                    <div class="body">
                        <el-form ref="newsTemplate" :model="newsTemplate" label-width="80px">
                            <el-form-item label="选择组件">
                                <el-select v-model="newsTemplate.current" placeholder="请选择组件" @change="changeTempate">
                                    <el-option v-for="newsTemplateItem in newsTemplate.list" :label="newsTemplateItem.newsTypeName" :value="newsTemplateItem" :key="newsTemplateItem.newsTypeId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="add-news-content" v-if="newsTemplate.current">
                    <div class="header">新闻内容</div>
                    <div class="body">
                        <BigImgAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-if="newsTemplate.current.newsTypeName === '大图新闻'"></BigImgAddNewsComponent>
                        <OneImgAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-else-if="newsTemplate.current.newsTypeName === '单图新闻'"></OneImgAddNewsComponent>
                        <TextAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-else-if="newsTemplate.current.newsTypeName === '无图新闻'"></TextAddNewsComponent>
                        <ThreeImgAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-else-if="newsTemplate.current.newsTypeName === '多图新闻'"></ThreeImgAddNewsComponent>
                        <VideoAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-else-if="newsTemplate.current.newsTypeName === '视频新闻'"></VideoAddNewsComponent>
                        <ImgListAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-else-if="newsTemplate.current.newsTypeName === '图集'"></ImgListAddNewsComponent>
                        <HeadImgAddNewsComponent :specialId="currentSpecial.specialId" :newsTypeId="newsTemplate.current.newsTypeId" :refreshNews="refreshNews" v-else-if="newsTemplate.current.newsTypeName === '头图'"></HeadImgAddNewsComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BigImgComponent from './newsTemplate/BigImg.vue';
import OneImgComponent from './newsTemplate/OneImg.vue';
import TextComponent from './newsTemplate/Text.vue';
import ThreeImgComponent from './newsTemplate/ThreeImg.vue';
import VideoComponent from './newsTemplate/Video.vue';
import HeadImgComponent from './newsTemplate/HeadImg.vue';
import ImgListComponent from './newsTemplate/ImgList.vue';

import BigImgAddNewsComponent from './newsAddTemplate/BigImg.vue';
import OneImgAddNewsComponent from './newsAddTemplate/OneImg.vue';
import TextAddNewsComponent from './newsAddTemplate/Text.vue';
import ThreeImgAddNewsComponent from './newsAddTemplate/ThreeImg.vue';
import VideoAddNewsComponent from './newsAddTemplate/Video.vue';
import ImgListAddNewsComponent from './newsAddTemplate/ImgList.vue';
import HeadImgAddNewsComponent from './newsAddTemplate/HeadImg.vue';

import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "editSpecialNews",
    data() {
        return {
            filterText: null,
            specialList: null,
            newsList: null,
            headImg: null,
            currentSpecial: null,
            newsTemplateList: null,
            showControl: true,
            newsTemplate: {
                current: null,
                list: null
            },
            propsRules: {
                children: null,
                label: "specialName"
            },
            config: {
                editNewsDialog: {
                    visible: false,
                    newsTypeName: null,
                    newsItem: null
                },
                rules: {
                    textNews: {
                        newsContentSource: [
                            { required: true, message: '请填写新闻来源', trigger: 'blur' }
                        ],
                        newsContentIsTop: [
                            { required: true, message: '请设置新闻置顶权重，默认为0', trigger: 'blur' }
                        ],
                        newsContentTitle: [
                            { required: true, message: '请填写新闻标题', trigger: 'blur' }
                        ],
                        newsContentURL: [
                            { required: true, message: '请填写落地链接', trigger: 'blur' }
                        ]
                    },
                    oneImgNews: {
                        newsContentSource: [
                            { required: true, message: '请填写新闻来源', trigger: 'blur' }
                        ],
                        newsContentIsTop: [
                            { required: true, message: '请设置新闻置顶权重，默认为0', trigger: 'blur' }
                        ],
                        newsContentTitle: [
                            { required: true, message: '请填写新闻标题', trigger: 'blur' }
                        ],
                        newsContentURL: [
                            { required: true, message: '请填写落地链接', trigger: 'blur' }
                        ],
                        newsContentImage: [
                            { required: true, message: '请填写图片链接', trigger: 'blur' }
                        ]
                    },
                    bigImgNews: {
                        newsContentSource: [
                            { required: true, message: '请填写新闻来源', trigger: 'blur' }
                        ],
                        newsContentIsTop: [
                            { required: true, message: '请设置新闻置顶权重，默认为0', trigger: 'blur' }
                        ],
                        newsContentTitle: [
                            { required: true, message: '请填写新闻标题', trigger: 'blur' }
                        ],
                        newsContentURL: [
                            { required: true, message: '请填写落地链接', trigger: 'blur' }
                        ],
                        newsContentImage: [
                            { required: true, message: '请填写图片链接', trigger: 'blur' }
                        ]
                    },
                    imgListNews: {
                        newsContentSource: [
                            { required: true, message: '请填写新闻来源', trigger: 'blur' }
                        ],
                        newsContentIsTop: [
                            { required: true, message: '请设置新闻置顶权重，默认为0', trigger: 'blur' }
                        ],
                        newsContentImage: [
                            { required: true, message: '请填写图片链接', trigger: 'blur' }
                        ]
                    },
                    threeImgNews: {
                        newsContentSource: [
                            { required: true, message: '请填写新闻来源', trigger: 'blur' }
                        ],
                        newsContentIsTop: [
                            { required: true, message: '请设置新闻置顶权重，默认为0', trigger: 'blur' }
                        ],
                        newsContentTitle: [
                            { required: true, message: '请填写新闻标题', trigger: 'blur' }
                        ],
                        newsContentURL: [
                            { required: true, message: '请填写落地链接', trigger: 'blur' }
                        ],
                        newsContentImage: [
                            { required: true, message: '请填写图片链接', trigger: 'blur' }
                        ]
                    },
                    videoNews: {
                        newsContentSource: [
                            { required: true, message: '请填写新闻来源', trigger: 'blur' }
                        ],
                        newsContentIsTop: [
                            { required: true, message: '请设置新闻置顶权重，默认为0', trigger: 'blur' }
                        ],
                        newsContentTitle: [
                            { required: true, message: '请填写新闻标题', trigger: 'blur' }
                        ],
                        newsContentURL: [
                            { required: true, message: '请填写视频链接', trigger: 'blur' }
                        ],
                        newsContentImage: [
                            { required: true, message: '请填写封皮图片链接', trigger: 'blur' }
                        ]
                    },
                    headImgNews: [

                    ]
                }
            }
        };
    },
    components: {
        BigImgComponent,
        OneImgComponent,
        TextComponent,
        ThreeImgComponent,
        VideoComponent,
        HeadImgComponent,
        ImgListComponent,
        BigImgAddNewsComponent,
        OneImgAddNewsComponent,
        TextAddNewsComponent,
        ThreeImgAddNewsComponent,
        VideoAddNewsComponent,
        ImgListAddNewsComponent,
        HeadImgAddNewsComponent
    },
    watch: {
        filterText(val) {
            this.$refs.specialTree.filter(val);
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    mounted(){
        this._init();
    },
    methods: {
         _getSpecialList() {
            this.$http.get(CONFIG.HOST + "/special/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _getNews(specialId = -1){
            this.$http.post(CONFIG.HOST + "/special/check" + "?t=" + TOOL.getCurrentTime(), {specialId: specialId}).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    if (Array.isArray(result.data) && result.data.length > 0 ) {
                        this.newsList = result.data;
                        this._formatHeadImg();
                        this._formatNews();
                    } else {
                        this.$notify.error({
                            message: '【营销平台】该商业专题暂无新闻'
                        });
                    }
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _formatNews(){
            if (Array.isArray(this.newsList)) {
                this.newsList.forEach((arrItem, index)=>{
                    switch (arrItem.newsTypeName) {
                        case '多图新闻':
                            arrItem.newsContentImage = arrItem.newsContentImage.indexOf(';') === -1? arrItem.newsContentImage: arrItem.newsContentImage.split(';');
                            break;
                        case '图集':
                            arrItem.newsContentImage = arrItem.newsContentImage.indexOf(';') === -1? arrItem.newsContentImage: arrItem.newsContentImage.split(';');
                            break;
                    }
                });
            }
        },
        _getTemplate(){
            this.$http.get(CONFIG.HOST + '/template/list' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.newsTemplate.list = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message) {
            return this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });          
        },
        _formatHeadImg(){
            this.headImg = null;
            if (!Array.isArray(this.newsList) || this.newsList.length <1) {
                return;
            }
            let firstNewsItem = this.newsList[0];
            if (firstNewsItem.newsTypeName !== '头图') {
                return;
            }
            let tmp = [];
            let arrImg = firstNewsItem.newsContentImage.split(';');   
            let arrLink = firstNewsItem.newsContentURL.split(';');             
            let arrLength = arrImg.length;
            for(let i = 0; i < arrLength; i++){
                tmp.push({
                    image: arrImg[i],
                    link: arrLink[i]
                });
            }
            this.headImg = tmp;
        },
        filterNode(value, data) {
            if (!value){
                return true;
            } 
            return data.specialName.indexOf(value) !== -1;
        },
        addSpecial(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.post(CONFIG.HOST + '/special/add', this.addSpecialForm).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】商业专题创建成功'
                    });
                    this.clearSpecialData();
                    router.push({
                        name: 'businessList'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        selectSpecial(data){
            this.newsList = null;
            this.currentSpecial = data;
            this._getNews(data.specialId);
        },
        refreshNews(){
            this._getNews(this.currentSpecial.specialId);
        },
        clearSpecialData(){
            this.addSpecialForm.specialName = null;
            this.addSpecialForm.company = null;
            this.addSpecialForm.createUser = null;
            this.addSpecialForm.specialImage = null;
            this.addSpecialForm.specialContent = null;
        },
        changeTempate(value){
            if (value === '头图') {
                this.$notify.error({
                    message: '【营销平台】商业专题不可添加头图新闻'
                });
            }
        },
        deleteNews(newsContentId){
            if (!isNaN(newsContentId) && newsContentId >= 0) {
                this.$http.delete(CONFIG.HOST + '/special/deleteNews/' + newsContentId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】ID：' + newsContentId + '的新闻删除成功'
                        });
                        this._getNews(this.currentSpecial.specialId);
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                     console.log(response);
                });
            }
        },
        _move(preId = -1, nextId = -1, callback=()=>{}){
            if (isNaN(preId) || isNaN(nextId)) {
                this.$notify.error({
                    message: "【营销平台】错误新闻IO"
                });
                return;
            }
            // alert(JSON.stringify({preId,nextId}))
            this.$http.put(CONFIG.HOST + '/special/changeNewsPosition', {
                firstNewsContentId: preId,
                secondNewsContentId: nextId
            }).then((response)=>{
                console.log(response)
                let result = response.body;
                if (result && result.status === 1) {
                    callback(true);
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        moveUp(arrIndex){
            try {
                this._move(this.newsList[arrIndex -1].newsContentId, this.newsList[arrIndex].newsContentId, (flag)=>{
                    if (flag) {
                        this.$notify.success({
                            message: '【营销平台】上移成功'
                        });
                        this._getNews(this.currentSpecial.specialId);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        moveDown(arrIndex){
            try {
                this._move(this.newsList[arrIndex].newsContentId, this.newsList[arrIndex + 1].newsContentId, (flag)=>{
                    if (flag) {
                        this.$notify.success({
                            message: '【营销平台】下移成功'
                        });
                        this._getNews(this.currentSpecial.specialId);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        _edit(newsItem){
            try {
                this.$http.put(CONFIG.HOST + '/special/updateNews', newsItem).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '【营销平台】新闻更新成功'
                        });
                        this.closeEditNewsDialog();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            } catch (error) {
                this.$notify.error({
                    message: error
                });
                this.closeEditNewsDialog();
            }
        },
        submitEditData(){
            let flag = true;
            let _newsItem = this.config.editNewsDialog.newsItem;
            let _submitNewsItem = {
                newsContentId: _newsItem?_newsItem.newsContentId : this.newsList[0].newsContentId,
                newsContentTitle: _newsItem? _newsItem.newsContentTitle : this.config.editNewsDialog.newsTypeName,
                newsContentUpdateUser: Base64.decode(this.$route.params.userId),
                newsContentImage: _newsItem?_newsItem.newsContentImage : this.newsList[0].newsContentImage,
                newsContentURL:_newsItem?_newsItem.newsContentURL : this.newsList[0].newsContentURL,
                newsContentSource: _newsItem?_newsItem.newsContentSource : '一点资讯',
                newsContentIsTop: _newsItem?_newsItem.newsContentIsTop : 0,
            };
            switch (this.config.editNewsDialog.newsTypeName) {
                case '无图新闻':
                    this.$refs['textNews'].validate((valid) => {
                        if (!valid) {
                            flag = false;
                            return false;
                        }
                    });
                    if (!flag) {
                        return;
                    }
                    break;
                case '单图新闻':
                    this.$refs['oneImgNews'].validate((valid) => {
                        if (!valid) {
                            flag = false;
                            return false;
                        }
                    });
                    if (!flag) {
                        return;
                    }
                    break;
                case '大图新闻':
                    this.$refs['bigImgNews'].validate((valid) => {
                        if (!valid) {
                            flag = false;
                            return false;
                        }
                    });
                    if (!flag) {
                        return;
                    }
                    break;
                case '多图新闻':
                    this.$refs['threeImgNews'].validate((valid) => {
                        if (!valid) {
                            flag = false;
                            return false;
                        }
                    });
                    if (!flag) {
                        return;
                    }
                    try {
                        let _arrStr = ''; 
                        _newsItem.newsContentImage.forEach((arrItem, index)=>{
                            if (index < _newsItem.newsContentImage.length - 1) {
                                _arrStr += arrItem + ';';
                            } else {
                                _arrStr += arrItem;
                            }
                        });
                        _submitNewsItem.newsContentImage = _arrStr;
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                case '视频新闻':
                    this.$refs['videoNews'].validate((valid) => {
                        if (!valid) {
                            flag = false;
                            return false;
                        }
                    });
                    if (!flag) {
                        return;
                    }
                    break;
                case '图集':
                    this.$refs['imgListNews'].validate((valid) => {
                        if (!valid) {
                            flag = false;
                            return false;
                        }
                    });
                    if (!flag) {
                        return;
                    }
                    try {
                        let _arrStr = ''; 
                        _newsItem.newsContentImage.forEach((arrItem, index)=>{
                            if (index < _newsItem.newsContentImage.length - 1) {
                                _arrStr += arrItem + ';';
                            } else {
                                _arrStr += arrItem;
                            }
                        });
                        _submitNewsItem.newsContentImage = _arrStr;
                        _submitNewsItem.newsContentTitle = '图集';
                        _submitNewsItem.newsContentURL = '#';
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                case '头图':
                    // alert(this.config.editNewsDialog.newsTypeName)
                    try {
                        let arrStr = {
                            image: '',
                            link: ''
                        };
                        // console.log('我是头图数组')
                        // console.log(this.headImg)
                        for(let i = 0; i < this.headImg.length; i++){
                            if (i < this.headImg.length -1) {
                                arrStr.image += this.headImg[i].image + ';';
                                arrStr.link += this.headImg[i].link + ';';
                            } else {
                                arrStr.image += this.headImg[i].image;
                                arrStr.link += this.headImg[i].link;
                            }
                        }
                        _submitNewsItem.newsContentImage = arrStr.image;
                        _submitNewsItem.newsContentURL = arrStr.link;
                        _submitNewsItem.newsContentTitle = '头图';
                    } catch (error) {
                        console.log(error);
                    }
                    break;
            }
            // console.log(_submitNewsItem)
            this.$http.put(CONFIG.HOST + '/special/updateNews', _submitNewsItem).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.closeEditNewsDialog();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        closeEditNewsDialog(){
            this.config.editNewsDialog.visible = false;
            this._getNews(this.currentSpecial.specialId);
        },
        editNews(newsItem){
            this.config.editNewsDialog.visible = true;
            this.config.editNewsDialog.newsTypeName = newsItem.newsTypeName;
            this.config.editNewsDialog.newsItem = newsItem;

        },
        editHeadImg(){
            this.config.editNewsDialog.newsTypeName = '头图';
            this.config.editNewsDialog.newsItem=null;
            this.config.editNewsDialog.visible = true;
        },
        addHeadImgCard(){
            this.headImg.push({
                image: null,
                link: '#'
            });
        },
        deleteHeadImgCard(){
            this.headImg.splice(this.headImg.length - 1, 1);
        },
        _init() {
            this._getSpecialList();
            this._getTemplate();
        }
    }
};
</script>
<style lang="less">
    .editSpecialNews{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .edit-special-news-box{
            width: 980px;
            position: relative;
            left: 0;
            top: 0;

            .special-list-box{
                width: 280px;
                float: left;

                .tree{
                    margin-top: 6px;
                    
                    .el-tree-node__expand-icon.is-leaf{
                        display: none;
                    }
                    .is-current{
                        .el-tree-node__content{
                            background-color: #324157;
                        }
                        color: #fff;
                    }
                }
            }
            .news-contents-box{
                width: 320px !important;
                height: 560px;
                overflow-y: auto;
                margin-bottom: 10px;
                position: relative;

                text-align: left;
                color: rgb(51, 51, 51);

                float: left;
                margin-left: 20px;

                border: 1px solid #bfcbd9;

                .refresh-btn-box{
                    width: 40px;
                    height: 40px;

                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 10000;

                    border-radius: 50%;

                    background: #fff;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }

                .special-desc-box{
                    padding: 10px 14px;
                    margin-bottom: 10px;

                    border-bottom: 1px solid #bfcbd9;

                    font-size: 10px;
                    line-height: 1.5;

                    .desc-icon{
                        color: #fff;
                        background: #0c9aee;
                        display: inline-flex;
                        padding-left: 2px;
                        padding-right: 2px;
                    }
                    .desc-content{

                    }
                }

                .news-list-box{
                    padding: 0 14px;
                    .news-item-box{
                        padding-bottom: 10px;
                        margin-bottom: 10px;
                        border-bottom: 1px solid #bfcbd9;
                    }
                }
            }
            .add-news-box{
                width: 340px;
                float: left;
                margin-left: 18px;
                .select-template-box{
                    border: 1px solid #bfcbd9;
                    .header{
                        padding: 10px 14px;
                        
                        border-bottom: 1px solid #bfcbd9;
                        
                        text-align: left;
                        color: rgb(51, 51, 51);
                    }
                    .body{
                        padding: 20px 0 0;
                    }
                }
                .add-news-content{
                    margin-top: 20px;

                    border: 1px solid #bfcbd9;
                    .header{
                        padding: 10px 14px;
                        
                        border-bottom: 1px solid #bfcbd9;
                        
                        text-align: left;
                        color: rgb(51, 51, 51);
                    }
                    .body{
                        padding: 20px 20px 0 0;
                    }
                }
            }
        }
        .box-card{
            margin-bottom: 10px;
        }
    }  
</style>


// WEBPACK FOOTER //
// Edit.vue?50c9c2ac